import styled from "styled-components";
import GameBox from "./GameBox";
import Game from "../Types/Game";
import { isOldGame } from "Helpers/util";

const GamesContainer = styled.div`
  margin: 1em auto;
  display: grid;
  grid-gap: 0.8em;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  width: 100%;
`;

interface GamesProps {
  games: { [gameId: string]: Game };
}

const Games = ({ games }: GamesProps) => (
  <GamesContainer>
    {Object.entries(games)
      .filter((g) => !isOldGame(g[1]))
      .map(([gameId, g]) => (
        <GameBox
          key={gameId}
          id={gameId}
          gameStatus={g.status}
          socketIds={g.socketIds ?? []}
        ></GameBox>
      ))}
  </GamesContainer>
);

export default Games;
